/** @jsxImportSource @emotion/react */

import { Typography } from "../../Typography";
import { Clay } from "../../utilities";
import type { ClayProps } from "../../utilities/Clay/Clay.types";
import type { TextareaCoreProps } from "../Textarea.types";

export type CharacterCountProps = Pick<TextareaCoreProps, "maxLength" | "value"> & ClayProps<"div">;

export const CharacterCount = ({ value, maxLength, ...clayProps }: CharacterCountProps) => {
  return (
    <Clay as="div" {...clayProps}>
      <Typography colorToken="textSub">
        {`${value ? value.length : 0}${maxLength ? `/${maxLength}` : ""}`}
      </Typography>
    </Clay>
  );
};
